import { loadModules } from 'esri-loader';
import { LAND_CHAR_TITLE, SPECIES_TITLE, WETLANDS_TITLE, POLLUTION_TITLE } from '../BSLAConstants';

const categoryTitles = [LAND_CHAR_TITLE, POLLUTION_TITLE, SPECIES_TITLE, WETLANDS_TITLE];

const BSLALayerList = async (view: __esri.View) => {
    type searchModules = [typeof import('esri/widgets/LayerList'), typeof import('esri/widgets/Expand')];

    const [LayerList, Expand] = await (loadModules(['esri/widgets/LayerList', 'esri/widgets/Expand']) as Promise<searchModules>);

    const layerList = new LayerList({
        view,
        listItemCreatedFunction: (evt) => {
            const item = evt.item;

            if (categoryTitles.indexOf(item.title) >= 0) {
                item.open = false;
            } else {
                item.open = true;
            }

            if (item.layer.type !== 'group') {
                item.panel = {
                    content: 'legend',
                    open: false
                };

                item.actionsSections = [
                    [
                        {
                            title: 'Increase opacity',
                            className: 'esri-icon-up',
                            id: 'increase-opacity'
                        },
                        {
                            title: 'Decrease opacity',
                            className: 'esri-icon-down',
                            id: 'decrease-opacity'
                        }
                    ]
                ];
            }
        }
    });

    layerList.on('trigger-action', (evt) => {
        const layer = evt.item.layer as __esri.Layer;
        const id = evt.action.id;

        if (id === 'increase-opacity') {
            if (layer.opacity < 1) {
                layer.opacity += 0.25;
            }
        } else if (id === 'decrease-opacity') {
            if (layer.opacity > 0) {
                layer.opacity -= 0.25;
            }
        }
    });

    return new Expand({
        view: view,
        content: layerList,
        expandTooltip: 'Layers',
        expanded: true
    });
};

export default BSLALayerList;
